import React, { useState, useRef, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import "./Home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MapWithSidebar from "../components/common/MapWithSidebar";
import Slider from "react-slick";
import imagen1 from "./images/imagen1.png";
import imagen2 from "./images/Image2.png";
import imagen3 from "./images/imagen3.png";
import imagen4 from "./images/imagen4.png";
import imagen5 from "./images/imagen5.png";
import imagen6 from "./images/imagen6.png";
import SlideImg from "./images/Slide.jpg";

const Home = () => {
  const { t, i18n } = useTranslation();
  const carouselRef = useRef(null);
  const sliderRef = useRef(null);
  const [autoScroll, setAutoScroll] = useState(true);
  const WA_URL = "https://wa.me/50660458068?text=¡Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20más%20información%20por%20favor.%20";

  useEffect(() => {
    document.title = t("meta.title");
  }, [t, i18n.language]);

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel || !autoScroll) return;
    const interval = setInterval(() => {
      if (
        carousel.scrollLeft + carousel.clientWidth >=
        carousel.scrollWidth - 10
      ) {
        carousel.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        carousel.scrollBy({ left: 320, behavior: "smooth" });
      }
    }, 3500);
    return () => clearInterval(interval);
  }, [autoScroll]);

  const ctaItems = t("ctaSection.list", { returnObjects: true });
  const cTitles = t("carousel.titles", { returnObjects: true });
  const cSubtitles = t("carousel.subtitles", { returnObjects: true });
  const cAlts = t("carousel.alts", { returnObjects: true });
  const testimonials = t("testimonials.items", { returnObjects: true });

  const businessJsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: t("seo.name"),
    image: "https://rollerup.gruposantamaria.cr//logo.png",
    description: t("seo.description"),
    areaServed: "Costa Rica",
    url: "https://rollerup.gruposantamaria.cr/",
    telephone: "+506 6045 8068",
    priceRange: "$$",
    sameAs: [
      "https://www.facebook.com/persianasrollerup",
      "http://instagram.com/persianasrollerup/",
    ],
  };

  return (
    <div className="home-container">
      {/* ===== HERO ===== */}
      <section className="hero-section" aria-labelledby="hero-title">
        <div className="hero-overlay"></div>

        {/* Video en lugar de la imagen */}
        <video
          className="hero-banner"
          src="https://gruposantamaria.cr/wp-content/uploads/2025/09/videoempresa.mp4"
          autoPlay
          loop
          muted
          playsInline
        >
          Tu navegador no soporta videos HTML5.
        </video>


        <div className="hero-content">
          <h1 id="hero-title">
            <span className="hero-title-line">{t("hero.titleLine")}</span>
            <span className="hero-title-highlight">
              {t("hero.titleHighlight")}
            </span>
          </h1>
          <p className="hero-subtitle">
            <Trans
              i18nKey="hero.subtitle"
              components={{ strong: <strong /> }}
            />
          </p>
          <button
            className="hero-cta-button"
            aria-label={t("aria.whatsappQuote")}
            onClick={() => window.open(WA_URL, "_blank", "noopener,noreferrer")}
          >
            <span>{t("hero.cta")}</span>
            <svg className="cta-icon" viewBox="0 0 24 24">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </section>

      {/* ===== INFO + CARRUSEL ===== */}
      <section className="py-40 bg-gray-50" aria-labelledby="about-title">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-6 items-center">
            <div className="lg:w-2/5 w-full bg-white rounded-xl p-8 shadow-lg z-10">
              <h2
                id="about-title"
                className="text-2xl font-bold mb-4 text-gray-900 leading-tight"
              >
                {t("about.title")}
              </h2>
              <p className="text-gray-600 mb-4 text-base leading-relaxed">
                <Trans i18nKey="about.p1" components={{ strong: <strong /> }} />
              </p>
              <p className="text-gray-600 mb-6 text-base leading-relaxed">
                <Trans i18nKey="about.p2" components={{ strong: <strong /> }} />
              </p>
              <button
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-300 text-lg font-bold shadow-md hover:shadow-lg hover:scale-[1.02]"
                onClick={() =>
                  window.open(
                    "https://flipbooks.gruposantamaria.cr/flipbook5/",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
                aria-label="Abrir Flipbooks (se abre en nueva pestaña)"
              >
                {t("about.btn")}
                <svg
                  className="w-6 h-6 ml-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 12h14m0 0l-6-6m6 6l-6 6"
                  />
                </svg>
              </button>
            </div>
            {/* Carrusel de categorías */}
            <div className="lg:w-3/5 w-full relative">
              <div
                ref={carouselRef}
                className="flex overflow-x-auto snap-x snap-mandatory gap-6 px-2 pb-6 scroll-smooth cat-carousel"
                style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                onMouseEnter={() => setAutoScroll(false)}
                onMouseLeave={() => setAutoScroll(true)}
                aria-label={t("carousel.aria")}
              >
                <div className="flex items-center gap-6 min-w-max cat-track">
                  {[imagen1, imagen2, imagen3, imagen4, imagen6].map(
                    (src, i) => (
                      <div
                        key={`img-${i}`}
                        className="flex-shrink-0 w-65 h-80 bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300 cat-card"
                      >
                        <img
                          src={src}
                          alt={cAlts[i] || ""}
                          className="w-full h-60 object-cover hover:scale-105 transition-transform duration-500 cat-img"
                          loading="lazy"
                        />
                        <div className="p-4 text-center">
                          <h3 className="text-xl font-bold text-gray-800 mb-1">
                            {cTitles[i]}
                          </h3>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>

              {/* Flechas */}
              <button
                className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md z-10 hover:bg-gray-100 transition-colors"
                onClick={() =>
                  carouselRef.current?.scrollBy({
                    left: -320,
                    behavior: "smooth",
                  })
                }
                aria-label={t("aria.prev")}
              >
                <svg
                  className="w-5 h-5 text-gray-800"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <button
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md z-10 hover:bg-gray-100 transition-colors"
                onClick={() =>
                  carouselRef.current?.scrollBy({
                    left: 320,
                    behavior: "smooth",
                  })
                }
                aria-label={t("aria.next")}
              >
                <svg
                  className="w-5 h-5 text-gray-800"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CTA con imagen ===== */}
      <section className="cta-section" aria-labelledby="why-title">
        <div
          className="cta-background"
          style={{ backgroundImage: `url(${SlideImg})` }}
        >
          <div className="cta-overlay" />
        </div>
        <div className="cta-content">
          <h2 id="why-title" className="cta-title">
            {t("ctaSection.title")}
          </h2>
          <ul className="cta-list">
            {ctaItems.map((html, idx) => (
              <li key={`cta-${idx}`}>
                <span dangerouslySetInnerHTML={{ __html: html }} />
              </li>
            ))}
          </ul>
          <div className="cta-buttons">
            <a
              href="https://wa.me/50660458068?text=¡Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20más%20información%20por%20favor.%20"
              className="cta-button primary"
              aria-label={t("aria.whatsappQuote")}
            >
              {t("ctaSection.buttons.quote")}
              <svg className="cta-icon" viewBox="0 0 24 24">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a
              href="https://flipbooks.gruposantamaria.cr/flipbook5"
              className="cta-button secondary"
            >
              {t("ctaSection.buttons.viewAll")}
            </a>
          </div>
        </div>
      </section>

      {/* ===== Testimonios ===== */}
      <section
        className="relative py-20 overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100"
        aria-labelledby="reviews-title"
      >
        <div className="absolute top-0 left-0 w-full h-full opacity-5">
          <div className="absolute top-20 left-10 w-40 h-40 bg-orange-400 rounded-full mix-blend-multiply filter blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-40 h-40 bg-amber-400 rounded-full mix-blend-multiply filter blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center mb-16">
            <h2
              id="reviews-title"
              className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            >
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-amber-500">
                {t("testimonials.titleLead")}
              </span>{" "}
              {t("testimonials.titleTrail")}
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              {t("testimonials.subtitle")}
            </p>
          </div>

          <div className="relative">
            <Slider
              ref={sliderRef}
              dots
              arrows={false}
              infinite
              speed={800}
              slidesToShow={2}
              slidesToScroll={2}
              autoplay
              autoplaySpeed={6000}
              pauseOnHover
              responsive={[
                { breakpoint: 1024, settings: { slidesToShow: 2 } },
                { breakpoint: 768, settings: { slidesToShow: 1 } },
              ]}
              className="testimonial-slider-fixed"
            >
              {testimonials.map((it, index) => (
                <div key={index} className="px-3 h-full outline-none">
                  <div className="bg-white p-8 rounded-2xl shadow-xl h-full flex flex-col border border-gray-100 transform transition-all duration-300 hover:shadow-2xl group relative">
                    <div
                      className="flex justify-center mb-6"
                      aria-label={`Rating ${it.rating} of 5`}
                    >
                      {[...Array(5)].map((_, i) => (
                        <svg
                          key={i}
                          className={`w-7 h-7 ${
                            i < it.rating ? "text-amber-400" : "text-gray-200"
                          }`}
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>

                    <div className="mb-6 flex-grow min-h-0">
                      <blockquote className="text-lg text-gray-700 relative h-full">
                        <span className="sr-only">Testimonio:</span>
                        <span className="absolute -top-6 -left-2 text-6xl text-orange-100 font-serif">
                          "
                        </span>
                        <p className="relative z-10 pl-6 line-clamp-5">
                          {it.quote}
                        </p>
                        <span className="absolute -bottom-6 -right-2 text-6xl text-orange-100 font-serif">
                          "
                        </span>
                      </blockquote>
                    </div>

                    <div className="mt-auto">
                      <div className="flex items-center">
                        <div className="mr-4">
                          <div className="w-14 h-14 rounded-full bg-gradient-to-r from-orange-400 to-amber-400 flex items-center justify-center text-white font-bold text-xl">
                            {it.name?.charAt(0)}
                          </div>
                        </div>
                        <div>
                          <p className="font-bold text-gray-900">{it.name}</p>
                        </div>
                      </div>
                    </div>

                    <div
                      className="absolute bottom-0 right-0 w-32 h-32 -z-10 opacity-10"
                      aria-hidden="true"
                    >
                      <svg
                        viewBox="0 0 200 200"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill="#F59E0B"
                          d="M45.1,-65.1C58.1,-58.3,68.3,-45.9,73.3,-31.5C78.3,-17.1,78.1,-0.7,74.1,13.6C70.1,27.9,62.3,40.1,51.2,49.7C40.1,59.4,25.7,66.5,9.9,72.2C-5.9,77.8,-23.1,82,-36.8,75.7C-50.5,69.3,-60.7,52.4,-67.4,34.5C-74.1,16.6,-77.3,-2.3,-72.5,-18.3C-67.7,-34.3,-55,-47.4,-40.1,-53.6C-25.2,-59.8,-8.1,-59.1,7.1,-66.9C22.3,-74.7,32.1,-91.9,45.1,-65.1Z"
                          transform="translate(100 100)"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>

            <div className="flex justify-center mt-8 space-x-4">
              <button
                onClick={() => sliderRef.current.slickPrev()}
                className="p-3 rounded-full bg-white shadow-lg hover:bg-gray-50 transition-all transform hover:scale-110 focus:outline-none"
                aria-label={t("aria.prev")}
              >
                <svg
                  className="w-6 h-6 text-orange-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <button
                onClick={() => sliderRef.current.slickNext()}
                className="p-3 rounded-full bg-white shadow-lg hover:bg-gray-50 transition-all transform hover:scale-110 focus:outline-none"
                aria-label={t("aria.next")}
              >
                <svg
                  className="w-6 h-6 text-orange-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      <a
        href="https://wa.me/50660458068?text=¡Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20más%20información%20por%20favor.%20"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="whatsapp-icon"
        >
          <path
            d="M16.003 3C9.375 3 4 8.373 4 15c0 2.647.87 5.089 2.344 7.059L4 29l7.172-2.316A11.948 11.948 0 0016.003 27c6.627 0 12-5.373 12-12S22.63 3 16.003 3zm0 21.9c-2.224 0-4.318-.654-6.1-1.884l-.436-.288-4.292 1.386 1.405-4.169-.285-.441A9.91 9.91 0 016.1 15c0-5.465 4.438-9.9 9.903-9.9 5.464 0 9.9 4.435 9.9 9.9 0 5.465-4.436 9.9-9.9 9.9zm5.427-7.364c-.297-.149-1.758-.867-2.03-.964-.273-.1-.471-.149-.668.15-.197.297-.767.963-.94 1.16-.174.198-.348.223-.645.075-.297-.15-1.254-.463-2.39-1.475-.883-.787-1.48-1.76-1.654-2.057-.173-.298-.018-.459.13-.607.134-.134.298-.348.447-.521.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.668-1.61-.915-2.205-.241-.579-.487-.5-.668-.51-.173-.01-.372-.012-.571-.012-.199 0-.521.075-.794.372-.273.298-1.044 1.018-1.044 2.48 0 1.462 1.07 2.874 1.219 3.072.149.199 2.107 3.223 5.105 4.52.714.308 1.27.492 1.705.629.716.227 1.367.195 1.883.118.574-.086 1.758-.718 2.006-1.41.248-.691.248-1.284.174-1.41-.074-.124-.272-.198-.57-.347z"
            fill="currentColor"
          />
        </svg>
      </a>

      {/* ===== Cobertura y Ubicaciones ===== */}
<section className="map-section" aria-labelledby="branches-title">
  <div className="section-header">
    <h2 id="branches-title" className="section-title">
      <span className="title-decoration">{t("map.titlePrefix")}</span>
    </h2>
    <div className="section-divider"></div>
  </div>

  <div className="map-container">
    <div className="map-frame">
      <MapWithSidebar />
    </div>
  </div>

  <div className="contact-cta">
    <p>{t("map.question")}</p>
    <a href="https://wa.me/50660458068?text=¡Buenas!%20Vengo%20del%20sitio%20web%20y%20quisiera%20más%20información%20por%20favor.%20" className="contact-link">
      {t("map.contact")} <span className="link-arrow">→</span>
    </a>
  </div>
</section>

      {/* ===== JSON-LD ===== */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(businessJsonLd) }}
      />
    </div>
  );
};

export default Home;
